// src/awardtoken.js
import { doc, setDoc, getDoc, increment } from "firebase/firestore";
import { db } from "./firebase";
import { getAuth } from "firebase/auth";

export async function awardToken(amount = 1) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return null;

  const userRef = doc(db, "users", user.uid);

  // 1) atomic increment
  await setDoc(userRef, { coins: increment(amount) }, { merge: true });

  // 2) read back the new value
  const snap = await getDoc(userRef);
  return snap.data().coins;          // returns new balance
}
